/* eslint-disable no-use-before-define */ import React from 'react';
import core from '@bbob/core';
import * as html from '@bbob/html';
import { isTagNode, isStringNode } from '@bbob/plugin-helper';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var toAST = function(source, plugins, options) {
    return core(plugins).process(source, _objectSpread({
    }, options, {
        render: function(input) {
            return html.render(input, {
                stripTags: true
            });
        }
    })).tree;
};
var isContentEmpty = function(content) {
    return !content || content.length === 0;
};
function tagToReactElement(node, index) {
    return React.createElement(node.tag, _objectSpread({
    }, node.attrs, {
        key: index
    }), isContentEmpty(node.content) ? null : renderToReactNodes(node.content));
}
function renderToReactNodes(nodes) {
    var els = [].concat(nodes).reduce(function(arr, node, index) {
        if (isTagNode(node)) {
            arr.push(tagToReactElement(node, index));
        } else if (isStringNode(node)) {
            arr.push(node);
        }
        return arr;
    }, []);
    return els;
}
function render(source, plugins, options) {
    return renderToReactNodes(toAST(source, plugins, options));
}
export { render };
export default render;
